import { logicContainerDefinition, logicRuleDefinition, topLevelLogicRules } from '../questions/schemaFields';

export function createBasicFinalSchema(type: string, properties = {}, required: string[] = []) {
  return {
    type: 'object',
    properties: {
      id: { type: 'string' },
      data: {
        type: 'object',
        properties: {
          type: { enum: [type] },
          isDefault: { type: 'boolean' },
          ...topLevelLogicRules,
          ...properties,
        },
        unevaluatedProperties: false,
        additionalProperties: false,
        required: ['type', ...required],
      },
    },
    additionalProperties: false,
    required: ['id', 'data'],
    definitions: { ...logicRuleDefinition, ...logicContainerDefinition },
  } as const;
}
